import { __decorate } from "tslib";
import { Component, Prop, Ref, Vue } from 'vue-property-decorator';
import { EventbusType, ModalType } from '@movecloser/front-core';
import throttle from 'lodash/throttle';
import { Search } from '@component/Search/Search.vue';
import { EModal } from '@contract/modal';
import { Inject } from '@plugin/inversify';
import { SiteLogoVariant, SiteServiceType } from '@service/site';
import { SitesNav } from '@component/SitesNav';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 * @author Agnieszka Zawadzka <agnieszka.zawadzka@movecloser.pl>
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 * @author Michał Rossian <michal.rossian@movecloser.pl>
 */
let Navbar = class Navbar extends Vue {
    constructor() {
        super(...arguments);
        /**
         * Determines whether the `<Sidebar>` component is currently open.
         */
        this.isSidebarOpen = false;
        this.isPinned = false;
        this.isSubNavHidden = false;
        this.isScrollUp = null;
        this.scrollTop = 0;
        this.stickyObserver = null;
        this.onScroll = throttle(this.onScrollCallback, 500);
    }
    /**
     * `[style]` declaration for the "my account" button.
     */
    // public myAccountBtnStyle: object | null = null
    /**
     * Determines whether the current application theme is `AppTheme.PremiumZone`.
     */
    // public get isPremiumZone (): boolean {
    //   return this.theme === AppTheme.PremiumZone
    // }
    /**
     * Determines whether the current application theme is `AppTheme.PremiumZone`.
     */
    get isKadeciRP() {
        return this.siteService.getActiveSite().id === 11;
    }
    /**
     * Return logged user
     */
    get user() {
        return this.$store.getters['profile/me'];
    }
    /**
     * Return checkIsPremium
     */
    get isPremium() {
        if (!this.user) {
            return false;
        }
        return !!(this.user.subscription && this.user.subscriptionPeriod !== null) || !!this.user.prevSubscription;
    }
    /**
     * Return subscription button target
     * @private
     */
    // private get subBtnTarget (): object {
    //   return this.isPremium ? { target: { name: 'profile.subscription' } }
    //     : { target: { name: 'subscription.choose.product' } }
    // }
    /**
     * Return user display name based on premium status
     */
    get userDisplayName() {
        if (!this.user) {
            return '';
        }
        if (this.isPremium) {
            const firstName = this.user.firstName || '';
            const lastName = this.user.lastName || '';
            return `${firstName} ${lastName}`.trim();
        }
        return this.user.email || '';
    }
    /**
     * Determines whether the User is currently logged-in.
     */
    get isUserLoggedIn() {
        return this.$store.getters['profile/isUserLoggedIn'];
    }
    /**
     * Determines whether the current page is homepage.
     */
    get isHomepage() {
        return this.$route.path === '/';
    }
    /**
     * Determines site meta title.
     */
    // public get siteMetaTitle (): string | null {
    //   return this.$store.getters.siteMetaTitle
    // }
    /**
     * Logotype SVG file to render.
     */
    get logotype() {
        const logoSize = this.site.properties.logoSize;
        return {
            src: this.site.logo[SiteLogoVariant.Light] || '',
            width: logoSize === null || logoSize === void 0 ? void 0 : logoSize.width,
            height: logoSize === null || logoSize === void 0 ? void 0 : logoSize.height
        };
    }
    /**
     * Return current Site.
     */
    get site() {
        return this.siteService.getActiveSite();
    }
    /**
     * Current application theme.
     */
    // private get theme (): AppTheme {
    //   return this.siteService.getActiveSiteTheme()
    // }
    /**
     * Close sidebar when click on link.
     */
    closeSidebar(event) {
        if (this.$route.path === '/') {
            event.preventDefault();
            window.scrollTo(0, 0);
        }
        this.eventBus.emit('ui:sidebar.close');
    }
    /**
     * Handles the `@click` event on the "menu" (hamburger) button.
     */
    onMenuBtnClick() {
        this.eventBus.emit('ui:sidebar.toggle');
    }
    /**
     * Handles the `@click` event on the "my account" button.
     */
    // public onMyAccountBtnClick (): void {
    //   this.goToMyAccount()
    // }
    /**
     * Handles the `@click` event on the "log-in" button.
     */
    onLogInBtnClick() {
        this.modalConnector.open(EModal.LogIn);
    }
    /**
     * Handles the `@click` event on the "search" button.
     * Toggle is searching value
     */
    // public onSearchClick (): void {
    //   this.$emit('toggleSearching')
    //   if (this.isSidebarOpen) {
    //     this.eventBus.emit('ui:sidebar.toggle')
    //   }
    // }
    /**
     * Attaches all the needed event listeners.
     */
    attachListeners() {
        this.eventBus.handle('ui:sidebar.changed', this.onSidebarChanged);
    }
    /**
     * Redirects the User to the "My account" view.
     */
    // private goToMyAccount (): void {
    //   this.$router.push({ name: 'profile.my-data' })
    // }
    /**
     * Handles the `ui:sidebar.changed` event emitted by the `EventBus`.
     */
    onSidebarChanged(event) {
        if (typeof event.payload === 'undefined') {
            return;
        }
        this.isSidebarOpen = event.payload.isOpen;
    }
    /**
     * Sets the absolute position of the "my account" button.
     */
    // private setMyAccountBtnPosition (): void {
    //   if (!this.isPremiumZone) {
    //     return
    //   }
    //
    //   if (!this.searchBtnRef) {
    //     throw new Error('<Navbar>.setMyAccountBtnPosition(): [this.searchBtnRef] is NOT available!')
    //   }
    //
    //   const searchBtnRect = this.searchBtnRef.$el.getBoundingClientRect()
    //
    //   this.myAccountBtnStyle = {
    //     top: searchBtnRect.top + searchBtnRect.height / 2 + 'px',
    //     left: searchBtnRect.left + 'px'
    //   }
    // }
    /**
     * Sets the value for the `--navbar-height` CSS variable.
     */
    setNavbarHeight(el, property = '--navbar-height') {
        const navbarHeight = typeof el !== 'undefined'
            ? typeof el.clientHeight === 'number'
                ? el.clientHeight + 'px' : undefined
            : undefined;
        if (typeof navbarHeight !== 'undefined') {
            // :root css selector can be reached with documentElement selector
            document.documentElement.style.setProperty(property, navbarHeight);
        }
    }
    watchScrollDirection() {
        this.scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        window.addEventListener('scroll', this.onScroll, { passive: true });
    }
    onScrollCallback() {
        var _a;
        const windowHeight = window.innerHeight;
        const top = window.pageYOffset || document.documentElement.scrollTop;
        if (top > this.scrollTop && this.isScrollUp !== false) {
            this.isScrollUp = false;
        }
        else if (top < this.scrollTop && this.isScrollUp !== true) {
            this.isScrollUp = true;
        }
        this.isSubNavHidden = top > windowHeight / 2;
        if (!this.isSidebarOpen) {
            this.isPinned = ((_a = this.navRef) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().top) === 0 && top > 0;
        }
        this.scrollTop = Math.max(0, top);
    }
    initStickyObserver() {
        if (!this.navRef) {
            return;
        }
        this.stickyObserver = new IntersectionObserver(([e]) => {
            if (this.isSidebarOpen) {
                return;
            }
            this.isPinned = e.intersectionRatio < 1;
        }, { threshold: [1] });
        this.stickyObserver.observe(this.navRef);
    }
};
__decorate([
    Prop({
        type: Array,
        required: false
    })
], Navbar.prototype, "links", void 0);
__decorate([
    Prop({
        type: Array,
        required: false
    })
], Navbar.prototype, "subLinks", void 0);
__decorate([
    Prop({
        type: Array,
        required: false
    })
], Navbar.prototype, "sitesLinks", void 0);
__decorate([
    Prop({
        type: String,
        required: false,
        default: ''
    })
], Navbar.prototype, "premiumButtonLink", void 0);
__decorate([
    Prop({
        type: String,
        required: false,
        default: ''
    })
], Navbar.prototype, "videoButtonLink", void 0);
__decorate([
    Prop({
        type: Boolean,
        required: false,
        default: true
    })
], Navbar.prototype, "showSubscriptionBtn", void 0);
__decorate([
    Ref('nav')
], Navbar.prototype, "navRef", void 0);
__decorate([
    Ref('navMain')
], Navbar.prototype, "navMainRef", void 0);
__decorate([
    Ref('navTop')
], Navbar.prototype, "navTopRef", void 0);
__decorate([
    Ref('searchBtn')
], Navbar.prototype, "searchBtnRef", void 0);
__decorate([
    Inject(EventbusType)
], Navbar.prototype, "eventBus", void 0);
__decorate([
    Inject(ModalType)
], Navbar.prototype, "modalConnector", void 0);
__decorate([
    Inject(SiteServiceType)
], Navbar.prototype, "siteService", void 0);
Navbar = __decorate([
    Component({
        name: 'Navbar',
        components: {
            Search,
            SitesNav
        },
        mounted() {
            this.attachListeners();
            this.setNavbarHeight(this.navRef, '--navbar-height');
            this.setNavbarHeight(this.navTopRef, '--navbar-top-height');
            this.setNavbarHeight(this.navMainRef, '--navbar-main-height');
            this.watchScrollDirection();
            // this.setMyAccountBtnPosition()
        },
        updated() {
            setTimeout(() => {
                this.setNavbarHeight(this.navRef, '--navbar-height');
                this.setNavbarHeight(this.navTopRef, '--navbar-top-height');
                this.setNavbarHeight(this.navMainRef, '--navbar-main-height');
            }, 400); // wait for animations to finish
        },
        beforeDestroy() {
            if (this.stickyObserver) {
                this.stickyObserver.unobserve(this.navRef);
            }
            window.removeEventListener('scroll', this.onScroll);
        }
    })
], Navbar);
export { Navbar };
export default Navbar;
